import SessionManager from '../utils/sessionManager';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://aptirix-version-610696728606.asia-south1.run.app/api';

function getAuthHeaders() {
  let currentSession = SessionManager.getCurrentSession();
  if (!currentSession || !currentSession.access_token) {
    currentSession = SessionManager.getSession('candidate');
  }
  const token = currentSession?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * AI Trainer: Send audio for immediate Gemini 2.5 Flash evaluation.
 * Returns { success, evaluation, spoken_feedback, transcript }
 */
export async function evaluateTrainerAnswer(audioBlob, sessionId, questionNumber) {
  const formData = new FormData();
  formData.append('audio', audioBlob, 'answer.webm');
  formData.append('session_id', sessionId);
  formData.append('question_number', String(questionNumber));

  const response = await fetch(`${API_BASE_URL}/audio-eval/trainer/evaluate`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
    },
    body: formData,
  });

  if (!response.ok) {
    const errText = await response.text().catch(() => 'Unknown error');
    throw new Error(`Trainer audio eval failed (${response.status}): ${errText}`);
  }

  return response.json();
}

/**
 * Assessment Interview: Upload audio to GCS for batch evaluation on /complete.
 * Returns { success, audio_url, message }
 */
export async function uploadInterviewAudio(audioBlob, interviewId, questionNumber) {
  const formData = new FormData();
  formData.append('audio', audioBlob, 'answer.webm');
  formData.append('interview_id', interviewId);
  formData.append('question_number', String(questionNumber));

  const response = await fetch(`${API_BASE_URL}/audio-eval/interview/upload-audio`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
    },
    body: formData,
  });

  if (!response.ok) {
    const errText = await response.text().catch(() => 'Unknown error');
    throw new Error(`Interview audio upload failed (${response.status}): ${errText}`);
  }

  return response.json();
}
